import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { editAdBanner, viewAdBanner } from "../../Redux/Actions/banner_adsActions";
import { useDispatch, useSelector } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import { viewCountryListPagination } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import "./editAdsBanner.css";

const EditAdsBanners = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const dropdownType = ["ad", "banner", "event"];
  const { countryList } = useSelector((state) => state.country);

  const [loading, setLoading] = useState(true);
  const [adsData, setAdsData] = useState({
    id: id,
    title: "",
    type: "",
    start_date: "",
    end_date: "",
    country_id: "",
    is_global: true,
    cover_photo: "",
    file_type: "",
    description: "",
    external_link: "",
  });

  // Fetch country list
  useEffect(() => {
    dispatch(viewCountryListPagination());
  }, [dispatch]);

  useEffect(() => {
    const fetchAdDetails = async () => {
      try {
        setLoading(true);
        const res = await dispatch(viewAdBanner(id));
        if (res?.statusCode === 200) {
          const data = res.data;
          setAdsData({
            id: id,
            title: data.title || "",
            type: data.type || "",
            start_date: data.start_date?.split("T")[0] || "",
            end_date: data.end_date?.split("T")[0] || "",
            country_id: data.country || "",
            is_global: data.is_global || true,
            cover_photo: data.cover_photo || "",
            file_type: data.file_type || "",
            description: data.description || "",
            external_link: data.external_link || "",
          });
        } else {
          toast.error("Failed to fetch banner details");
          navigate("/dealsAndOffers");
        }
      } finally {
        setLoading(false);
      }
    };
    fetchAdDetails();
  }, [dispatch, id, navigate]);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setAdsData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const fileType = adsData.cover_photo?.split(".").pop().toLowerCase();
    const imageTypes = ["jpeg", "jpg", "png"];
    const videoTypes = ["mp4", "avi"];

    if (imageTypes.includes(fileType)) {
      adsData.file_type = "image";
    } else if (videoTypes.includes(fileType)) {
      adsData.file_type = "video";
    }

    try {
      const response = await dispatch(editAdBanner(adsData));
      if (response?.statusCode === 200) {
        // toast.success("Updated Successfully");
        navigate("/dealsAndOffers");
      } else {
        toast.error(response?.message || "Update failed");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  if (loading) {
    return (
      <MainLayout>
        <div className="eab-loader-wrap">
          <div className="eab-loader" />
          <p className="eab-loader-text">Loading banner details…</p>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="eab-wrapper">
        <div className="eab-header">
          <div className="eab-header-left">
            <div className="eab-header-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </div>
            <div>
              <h1 className="eab-title">Edit Ads & Banners</h1>
              <p className="eab-subtitle">Update the details of this advertisement or banner</p>
            </div>
          </div>
          <button className="eab-view-btn" type="button" onClick={() => navigate("/dealsAndOffers")}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>
            </svg>
            View List
          </button>
        </div>

        <div className="eab-form">

          <div className="eab-card">
            <div className="eab-card-header">
              <span className="eab-card-badge">01</span>
              <h2 className="eab-card-title">Basic Information</h2>
            </div>
            <div className="eab-grid eab-grid-2">
              <div className="eab-field">
                <label className="eab-label">Title <span className="eab-req">*</span></label>
                <input
                  className="eab-input"
                  type="text"
                  name="title"
                  value={adsData.title}
                  onChange={handleEditChange}
                  placeholder="Enter title"
                />
              </div>

              <div className="eab-field">
                <label className="eab-label">Type <span className="eab-req">*</span></label>
                <select className="eab-select" name="type" value={adsData.type} onChange={handleEditChange}>
                  <option value="">Select Type</option>
                  {dropdownType.map((item) => (
                    <option key={item} value={item}>
                      {item.charAt(0).toUpperCase() + item.slice(1)}
                    </option>
                  ))}
                </select>
              </div>

              <div className="eab-field">
                <label className="eab-label">Country <span className="eab-req">*</span></label>
                <select className="eab-select" name="country_id" value={adsData.country_id} onChange={handleEditChange}>
                  <option value="">Select Country</option>
                  {Array.isArray(countryList?.data)
                    ? countryList.data.map((country) => (
                        <option key={country._id} value={country._id}>{country.country_name}</option>
                      ))
                    : null}
                </select>
              </div>

              <div className="eab-field eab-field--full">
                <label className="eab-label">Description <span className="eab-req">*</span></label>
                <textarea
                  className="eab-textarea"
                  name="description"
                  value={adsData.description}
                  onChange={handleEditChange}
                  rows={3}
                  placeholder="Enter a description…"
                />
              </div>

              <div className="eab-field">
                <label className="eab-label">External Link</label>
                <input
                  className="eab-input"
                  type="text"
                  name="external_link"
                  value={adsData.external_link}
                  onChange={handleEditChange}
                  placeholder="https://example.com"
                />
              </div>
            </div>
          </div>

          <div className="eab-card">
            <div className="eab-card-header">
              <span className="eab-card-badge">02</span>
              <h2 className="eab-card-title">Validity Period</h2>
            </div>
            <div className="eab-grid eab-grid-2">
              <div className="eab-field">
                <label className="eab-label">Start Date <span className="eab-req">*</span></label>
                <input
                  className="eab-input"
                  type="date"
                  name="start_date"
                  value={adsData.start_date}
                  onChange={handleEditChange}
                />
              </div>
              <div className="eab-field">
                <label className="eab-label">End Date <span className="eab-req">*</span></label>
                <input
                  className="eab-input"
                  type="date"
                  name="end_date"
                  value={adsData.end_date}
                  onChange={handleEditChange}
                />
              </div>
            </div>
          </div>

          <div className="eab-card">
            <div className="eab-card-header">
              <span className="eab-card-badge">03</span>
              <h2 className="eab-card-title">Banner / Media <span className="eab-req">*</span></h2>
            </div>

            <input
              accept=".jpg,.jpeg,.png,.mp4,.avi"
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  const allowed = [
                    "image/jpeg", "image/jpg", "image/png",
                    "video/mp4", "video/x-msvideo",
                  ];
                  if (!allowed.includes(file.type)) {
                    toast.error("Invalid file type!");
                    return;
                  }
                  const url = await AddImage(file);
                  if (url) {
                    setAdsData((prev) => ({ ...prev, cover_photo: url }));
                  }
                }
              }}
              id="eab-media-upload"
              type="file"
              hidden
            />

            <label className="eab-upload-zone" htmlFor="eab-media-upload">
              {adsData.cover_photo ? (
                <span className="eab-upload-success">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  File uploaded — click to replace
                </span>
              ) : (
                <>
                  <div className="eab-upload-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="17 8 12 3 7 8"/>
                      <line x1="12" y1="3" x2="12" y2="15"/>
                    </svg>
                  </div>
                  <span className="eab-upload-text">Click to upload image or video</span>
                  <span className="eab-upload-hint">JPG, PNG, MP4, AVI</span>
                </>
              )}
            </label>

            <ImageShowerModalGlobal
              keyField="cover_photo"
              setState={setAdsData}
              state={adsData}
              file={adsData.cover_photo}
            />
          </div>

          <div className="eab-footer">
            <button type="button" className="eab-btn eab-btn--cancel" onClick={() => navigate("/dealsAndOffers")}>
              Cancel
            </button>
            <button type="button" className="eab-btn eab-btn--submit" onClick={handleSubmit}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Update
            </button>
          </div>

        </div>
      </div>
    </MainLayout>
  );
};

export default EditAdsBanners;